import { BrowserRouter, Route, Routes } from "react-router-dom";
import HomePage from "./page/HomePage";
import HomePage2 from "./page/HomePage2";
import ThemeProvider from "./theme";

export default function App() {
  console.log(process.env);
  return (
    <>
      <ThemeProvider>
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/card-detection" element={<HomePage2 />} />
            </Routes>
          </BrowserRouter>
      </ThemeProvider>
    </>
  );
}
